export const TENANT_INACTIVE_EVENT = 'tenant:inactive';

export interface TenantInactiveEventDetail {
  isAdmin?: boolean;
}

export const dispatchTenantInactiveEvent = (isAdmin?: boolean) =>
  window.dispatchEvent(
    new CustomEvent<TenantInactiveEventDetail>(TENANT_INACTIVE_EVENT, {
      detail: { isAdmin },
    })
  );
